import { createIndexedDbStore } from '@siteminder/authx-trusted-device-client'

export interface TrustedDeviceRecord {
  email: string
  deviceId: string
  privateKey: CryptoKey
  enrolledAt: string
  label: string
}

const trustedDeviceStore = createIndexedDbStore<TrustedDeviceRecord>({
  dbName: 'authx-trusted-devices',
  dbVersion: 1,
  storeName: 'device-keys',
  keyPath: 'email',
  indexes: [],
})

export const saveDeviceKey = trustedDeviceStore.save.bind(trustedDeviceStore)
export const getDeviceKey = trustedDeviceStore.get.bind(trustedDeviceStore)
export const removeDeviceKey = trustedDeviceStore.remove.bind(trustedDeviceStore)
export const hasDeviceKey = trustedDeviceStore.has.bind(trustedDeviceStore)
